import { render, staticRenderFns } from "./YozemiView.vue?vue&type=template&id=d2315544&scoped=true&"
import script from "./YozemiView.vue?vue&type=script&lang=js&"
export * from "./YozemiView.vue?vue&type=script&lang=js&"
import style0 from "./YozemiView.vue?vue&type=style&index=0&id=d2315544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2315544",
  null
  
)

export default component.exports